exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".person-select .search-group .filter-item {\n  margin-bottom: 0.625rem;\n}\n.person-select .transfer-box {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 1.25rem;\n}\n.person-select .assign-select-footer {\n  text-align: right;\n}\n.person-select .assign-select-footer .number {\n  margin-right: 1.25rem;\n}\n.person-select .assign-select-footer .number .color {\n  color: #FFAA00;\n}\n.person-select .selected-col .title {\n  text-align: center;\n}\n.remind-person .footer {\n  text-align: right;\n}", ""]);

// exports
